import PropTypes, { oneOfType } from 'prop-types';
import React from 'react';
import {
  ENABLE_ORG_MANAGEMENT, ORG_PATHS,
} from '../constants';
import { Switch, Route } from 'react-router';
import OrgNavMenu from '../containers/org/OrgNavMenu';
import PersonNavMenu from './PersonNavMenu';

const NavMenu = (props) => {
    const { location, isOpen, navToggle, isLoggedIn, isMobile, isBreadCrumb, renderBreadCrumb } = props;

    const styles = styles || {};

    const menuProps = { location, navToggle, isOpen, isMobile, isBreadCrumb, renderBreadCrumb };

    const MenuLoggedIn = (
      <Switch>
        {ENABLE_ORG_MANAGEMENT && <Route path={ORG_PATHS.BASE} render={() => <OrgNavMenu {...menuProps} />} />}
        <Route render={() => <PersonNavMenu {...menuProps} />} />
      </Switch>
    );
    //need to revisit for a better solution //
    const menu = (isLoggedIn === undefined || isLoggedIn) ? MenuLoggedIn : null;

    return (props.noRender) ? null : menu;
};

const { object, func, bool, shape, node, string, array } = PropTypes;

NavMenu.propTypes = {
  location: object.isRequired,
  navToggle: func,
  noRender: bool,
  isOpen: bool,
  isLoggedIn: bool,
  isMobile: bool,
  isBreadCrumb: bool,
  renderBreadCrumb: func,
  icons: shape({
    iconActive: node,
    iconInactive: node
  }),
  // Will warn sometimes until all are changed to Styled-Components: string VS array //
  styles: shape({
    ulCommon: oneOfType([array, string]),
    ulActive: oneOfType([array, string]),
    ulInactive: oneOfType([array, string]),
    liCommon: oneOfType([array, string]),
    liActive: oneOfType([array, string]),
    liInactive: oneOfType([array, string]),
    aCommon: oneOfType([array, string]),
    aActive: oneOfType([array, string]),
    aInactive: oneOfType([array, string]),
    firstChildStyles: object,
    lastChildStyles: object,
  })
};

export default NavMenu;
